//#region Styles
import { Container } from "./styles";
//#endregion

const OrDivider = ({ height }) => {
    return (
        <Container height={height}>
            <span>o</span>
        </Container>
    );
}

export default OrDivider;